export const WEATHER_DATA_HISTORY_LENGTH = 5;